import { useEffect } from "react";

/**
 * Custom hook to set the document title
 * @param {string} title - The page-specific title (e.g., "Appointments History")
 * @param {string} appName - The application name (defaults to "My Sleep Coach")
 * @returns {void}
 */
const useDocumentTitle = (title, appName = "My Sleep Coach") => {
  useEffect(() => {
    const previousTitle = document.title;

    // Set the new title in the format "Page Title | App Name"
    if (title) {
      document.title = `${title} | ${appName}`;
    } else {
      document.title = appName;
    }

    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [title, appName]);
};

export default useDocumentTitle;
